import { render, staticRenderFns } from "./SalesCardState.vue?vue&type=template&id=c0b7c480&scoped=true"
import script from "./SalesCardState.vue?vue&type=script&lang=js"
export * from "./SalesCardState.vue?vue&type=script&lang=js"
import style0 from "./SalesCardState.vue?vue&type=style&index=0&id=c0b7c480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b7c480",
  null
  
)

export default component.exports